var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mb-5"},[_c('div',{staticClass:"my-6 mx-md-5 mt-md-7"},[_c('canvas',{ref:"chart"})])])}
var staticRenderFns = []

export { render, staticRenderFns }